// extracted by mini-css-extract-plugin
export default {"root":"UniqueSellingPoint-root","icon":"UniqueSellingPoint-icon","text":"UniqueSellingPoint-text"};